import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    Drawer,
    FormControlLabel,
    IconButton,
    Typography,
    Grid,
    FormControl,
    Select,
    TextField,
    MenuItem
} from '@mui/material';
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import ClearIcon from '@mui/icons-material/Clear';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ptBR } from "date-fns/locale";
import React, { useEffect, useState } from 'react';
import KanbanPriorityAutoComplete from '../KanbanPriorityAutoComplete';
import KanbanTagsAutoComplete from '../KanbanTagsAutoComplete';
import CreateOrEditKanbanPriorityModal from '../CreateOrEditKanbanPriorityModal';
import KanbanUsersAutoComplete from '../KanbanUsersAutoComplete';
import IdentifyGender from '../../helpers/IdentifyGender';
import ContactFilterAutoComplete from '../ContactFilterAutoComplete';
import AddIcon from '@mui/icons-material/Add';
import CreateOrEditKanbanTagModal from '../CreateOrEditKanbanTagModal';

const KanbanFiltersDrawer = ({ open, onClose, existStartedColumn, existFinishedColumn, kanban, priorities, cardTags, loadingPriority, loadingTag, taskTitle, onFilter }) => {

    const [openPriorityModal, setOpenPriorityModal] = useState(false);
    const [assigneds, setAssigneds] = useState([]);
    const [showTaskCount, setShowTaskCount] = useState(false);
    const [showCreatedBy, setShowCreatedBy] = useState(false);
    const [showTaskNumber, setShowTaskNumber] = useState(false);
    const [showTags, setShowTags] = useState(false);
    const [priorityFilter, setPriorityFilter] = useState(null);
    const [assignedFilter, setAssignedFilter] = useState([]);
    const [createdByFilter, setCreatedByFilter] = useState([]);
    const [loadingAssigneds, setLoadingAssigneds] = useState(true);
    const [requester, setRequester] = useState(null);
    const [startAt, setStartAt] = useState(null);
    const [endAt, setEndAt] = useState(startAt || null);
    const [filterDateBy, setFilterDateBy] = useState(null);
    const [viewCardPriority, setViewCardPriority] = useState(true);
    const [selectedTags, setSelectedTags] = useState([]);
    const [openTagModal, setOpenTagModal] = useState(false);

    useEffect(() => {
        setLoadingAssigneds(true);
        setAssigneds(kanban?.assigneds || []);
        setLoadingAssigneds(false);
    }, [kanban]);

    const resetFilters = () => {
        setPriorityFilter(null);
        setAssignedFilter([]);
        setCreatedByFilter([]);
        setShowTaskCount(false);
        setShowTaskNumber(false);
        setShowCreatedBy(false);
        setShowTags(false);
        setStartAt(null);
        setEndAt(null);
        setRequester(null);
        setFilterDateBy(null);
        setViewCardPriority(false);
        setSelectedTags([]);
    };

    const handleClose = () => {
        onClose(false);
    };

    const updatePriorityValue = (values, setFunction) => {
        if (!values || values.length === 0 || (values.length === 1 && values[0] === undefined)) {
            setFunction([]);
        } else {
            setFunction([values[values.length - 1]]);
        }
    };

    const updateTagsValue = (values, setFunction) => {
        if (!values || values.length === 0 || (values.length === 1 && values[0] === undefined)) {
            setFunction([]);
        } else {
            setFunction(values);
        }
    };

    const applyFilters = () => {
        const filters = {
            showTaskCount,
            showTaskNumber,
            showCreatedBy,
            showTags,
            priorityFilter,
            assignedFilter,
            createdByFilter,
            startAt,
            endAt,
            requester,
            filterDateBy,
            viewCardPriority,
            selectedTags
        };
        localStorage.setItem(`kanbanFilters_${kanban?.id}`, JSON.stringify(filters));
        onFilter(filters);
        handleClose();
    };

    useEffect(() => {
        if (!open || !kanban?.id) return;
        resetFilters();
        const savedFilters = localStorage.getItem(`kanbanFilters_${kanban?.id}`);
        if (savedFilters) {
            const parsedFilters = JSON.parse(savedFilters);
            setShowTaskCount(parsedFilters?.showTaskCount);
            setShowTaskNumber(parsedFilters?.showTaskNumber);
            setShowCreatedBy(parsedFilters?.showCreatedBy);
            setShowTags(parsedFilters?.showTags);
            setPriorityFilter(parsedFilters?.priorityFilter);
            setAssignedFilter(parsedFilters?.assignedFilter);
            setCreatedByFilter(parsedFilters?.createdByFilter);
            setStartAt(parsedFilters?.startAt ? new Date(parsedFilters?.startAt) : null);
            setEndAt(parsedFilters?.endAt ? new Date(parsedFilters?.endAt) : null);
            setRequester(parsedFilters?.requester);
            setFilterDateBy(parsedFilters?.filterDateBy);
            setViewCardPriority(parsedFilters?.viewCardPriority || false);
            setSelectedTags(parsedFilters?.selectedTags || []);
        }
    }, [open, kanban]);

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={() => handleClose()}
            PaperProps={{
                sx: {
                    width: 500,
                    p: 0,
                    backdropFilter: 'blur(20px)',
                },
            }}>
            <Grid container spacing={2} sx={{ p: 3 }}>

                {/* Header */}
                <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <FilterListIcon
                                color="primary"
                                sx={{ marginRight: '5px' }}
                            />
                            <Typography variant="h6" color="primary">
                                Filtros Kanban
                            </Typography>
                        </Box>
                        <IconButton onClick={() => handleClose()}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {/* Display Settings Section */}
                <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                        Configurações de Exibição
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={1}>

                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showTaskCount}
                                        onChange={(e) => setShowTaskCount(e.target.checked)}
                                    />
                                }
                                label="Exibir Contagem de Tarefas"
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showTags}
                                        onChange={(e) => setShowTags(e.target.checked)}
                                    />
                                }
                                label="Exibir Marcadores"
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={viewCardPriority}
                                        onChange={(e) => setViewCardPriority(e.target.checked)}
                                    />
                                }
                                label="Exibir nome da prioridade"
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showTaskNumber}
                                        onChange={(e) => setShowTaskNumber(e.target.checked)}
                                    />
                                }
                                label={`Exibir Número ${(IdentifyGender(taskTitle) == 'm' || IdentifyGender(taskTitle) == 'n') ? 'do' : 'da'} ${taskTitle.charAt(0).toUpperCase() + taskTitle.slice(1)}`}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showCreatedBy}
                                        onChange={(e) => setShowCreatedBy(e.target.checked)}
                                    />
                                }
                                label="Exibir Autoria nos cards"
                            />
                        </Grid>

                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {/* Task Filters Section */}
                <Grid item xs={12}>
                    <Divider>Filtro de datas</Divider>
                </Grid>

                <Grid item xs={12}>
                    <FormControl fullWidth size="small">
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={filterDateBy}
                            onChange={(e) => setFilterDateBy(e.target.value)}
                            sx={{
                                paddingRight: '5px',
                                '& .MuiSelect-select-root': {
                                    padding: '6px 5px 6px 0px'
                                }
                            }}
                            startAdornment={
                                <>
                                    <Typography
                                        sx={{
                                            '& .MuiOutlinedInput-root': { padding: '4px 5px 4px 6px !important' },
                                            fontSize: '0.75rem',
                                            fontWeight: 600,
                                            width: '100px',
                                            color: (theme) => theme.palette.text.secondary
                                        }}
                                    >
                                        Filtrar por
                                    </Typography>
                                    <Divider sx={{ margin: '0px 10px' }} orientation="vertical" flexItem />
                                </>
                            }
                            endAdornment={
                                <>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {filterDateBy != null && (
                                            <IconButton onClick={() => setFilterDateBy(null)} sx={{ padding: 0 }}>
                                                <ClearIcon sx={{ color: (theme) => theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000' }} />
                                            </IconButton>
                                        )}
                                        <AddIcon />
                                    </Box>
                                </>
                            }
                        >
                            <MenuItem value="created">Data de Criação</MenuItem>
                            <MenuItem disabled={!existStartedColumn} value="started">
                                {existStartedColumn ? 'Data de Início' : 'Data de Início (Parâmetro desativado)'}
                            </MenuItem>
                            <MenuItem disabled={!existFinishedColumn} value="finished">
                                {existFinishedColumn ? 'Data de Conclusão' : 'Data de Conclusão (Parâmetro desativado)'}
                            </MenuItem>

                        </Select>
                    </FormControl>
                </Grid>

                {filterDateBy !== null && <Grid item xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <DatePicker
                                    disabled={filterDateBy === null}
                                    label="Inicio"
                                    value={startAt}
                                    onChange={(newValue) => setStartAt(newValue)}
                                    format="dd/MM/yyyy"
                                    slotProps={{
                                        textField: {
                                            size: 'small', sx: { '& .MuiOutlinedInput-root': { height: '35px' } }, fullWidth: true, margin: 'dense', InputProps: !!startAt ? {
                                                startAdornment: (
                                                    <IconButton
                                                        sx={{
                                                            padding: '0px 5px 0px 0px'
                                                        }}
                                                        onClick={() => setStartAt(null)}>
                                                        <ClearIcon />
                                                    </IconButton>
                                                )
                                            } : {}
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <DatePicker
                                    disabled={filterDateBy === null}
                                    label="Fim"
                                    value={endAt}
                                    onChange={(newValue) => setEndAt(newValue)}
                                    format="dd/MM/yyyy"
                                    minDate={new Date(startAt)}
                                    slotProps={{
                                        textField: {
                                            size: 'small', sx: { '& .MuiOutlinedInput-root': { height: '35px' } }, fullWidth: true, margin: 'dense', InputProps: !!endAt ? {
                                                startAdornment: (
                                                    <IconButton
                                                        sx={{
                                                            padding: '0px 5px 0px 0px'
                                                        }}
                                                        onClick={() => setEndAt(null)}>
                                                        <ClearIcon />
                                                    </IconButton>
                                                ),
                                            } : {}
                                        }
                                    }}
                                />
                            </Grid>
                            <Typography variant="caption" color="textSecondary" sx={{ padding: '0px 20px' }}>
                                Ao selecionar apenas uma das datas, o filtro será aplicado apenas para o dia selecionado.
                            </Typography>
                        </Grid>
                    </LocalizationProvider>
                </Grid>}

                <Grid item xs={12}>
                    <Divider>  Filtros de Tarefas</Divider>
                </Grid>

                <Grid item xs={12}>
                    <ContactFilterAutoComplete
                        placeholder="Por Solicitante"
                        selectedContact={requester}
                        setSelectedContact={setRequester}
                    />
                </Grid>

                <Grid item xs={12}>
                    <KanbanUsersAutoComplete
                        labels={assigneds || []}
                        placeholder="Por autoria"
                        search={"Filtrar autorias"}
                        setValue={setCreatedByFilter}
                        value={createdByFilter || []}
                        loading={loadingAssigneds}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {/* Footer Buttons */}
                <Grid item xs={12}>
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            padding: 2,
                            zIndex: 1201,
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Button variant="outlined" onClick={resetFilters}>
                            Limpar filtros
                        </Button>
                        <Button variant="contained" color="primary" onClick={() => applyFilters()}>
                            Aplicar
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            <CreateOrEditKanbanPriorityModal
                open={openPriorityModal}
                onClose={setOpenPriorityModal}
                kanbanId={kanban?.id}
            />

            <CreateOrEditKanbanTagModal
                open={openTagModal}
                onClose={setOpenTagModal}
                kanbanId={kanban?.id}
            />

        </Drawer>
    );
};

export default KanbanFiltersDrawer;